import React, {useState, useEffect, Fragment} from 'react'
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import { getInitialMonthReport } from '../../actions/HRActions';
import {  
    getDoctors
} from '../../actions/adminActions';
import { RESET_INITIAL_MONTH_DATA } from '../../constants/HRConstants';
import { useDispatch, useSelector } from 'react-redux';
import ExportReactCSV from '../../components/ExportReactCSV';
import { useAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import Loader from '../../layouts/Loader';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';
import { formatDeviceAssignedDate, formatDob } from '../../utils/dateFormat';

const INITIAL_MONTH_SORT_COLUMNS = {
    name: { type: 'name', value: personName },
    dob: { type: 'date', value: (p) => p?.DOB },
    emrId: { type: 'string', value: (p) => p?.emrId },
    provider: { type: 'name', value: (p) => personName(p?.assigned_doctor_id) },
    nurse: { type: 'name', value: (p) => personName(p?.assigned_hr_id) },
};

const InitialMonthReport = () => {
    const alert = useAlert();

    const [month, setMonth] = useState('August');
    const dispatch = useDispatch();

    const [currentPage, setCurrentPage] = useState(1);
    const [resPerPage, setResPerPage] = useState(20);
    const [year, setYear] = useState("2023");

    const {loading, error, initialMonthPatients} = useSelector(state => state.initialMonthReport);
    const { doctors } = useSelector(state => state.doctor);

    const [doctorId, setDoctorId] = useState('');
    const tableSort = useSortableTable(initialMonthPatients?.data, { id: 'admin.initialMonthReport', columns: INITIAL_MONTH_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });

    useEffect(() => {
        if(error){
            alert.error(error);
            return 
        }
        dispatch(getDoctors(resPerPage, currentPage));
    }, [error]);

    const resetHandler = () => {
        dispatch({
            type: RESET_INITIAL_MONTH_DATA
        })
    }

    const generateInitialReport = () => {
        dispatch(getInitialMonthReport(doctorId, month, year))
    }

  return (
    <Fragment>
        <MetaData title="Initial Month Report"/>
        <Sidebar />    

        <section className="home-section">
        {/* TopBar */}
        <TopBar />

        <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded-card" style={{backgroundColor: '#FAFAFA'}}>
            <div className="home-content">

                <div className="row-display">
                    <h5 style={{color: '#004aad'}}>
                        <i className="bx bx-edit"></i> <strong>&nbsp;Initial Month Report </strong>
                    </h5>
                
                    <div className="row-display">
                        <Link to="/adminDashboard">
                            <button className="btn btn-secondary btn-sm">
                                <i className='bx bx-arrow-back'></i>
                            </button>
                        </Link>
                        &nbsp;&nbsp;
                        <Link to="/adminDashboard">
                            <button className="btn btn-secondary btn-sm">
                            <i className='bx bxs-home'></i>
                            </button>
                        </Link>
                    </div>   
                </div>
                <hr />
                
                <div className="row-display">
                <div className="col-md-3">
                <label htmlFor="from" className="profile-label">Select Month </label>
                        <select 
                            label="From" 
                            name="from" 
                            className="form-control"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                        >
                            <option value="SelectMonth">Select Month</option>
                            <option value="January">January</option>
                            <option value="February">February</option>
                            <option value="March">March</option>
                            <option value="April">April</option>
                            <option value="May">May</option>
                            <option value="June">June</option>
                            <option value="July">July</option>
                            <option value="August">August</option>
                            <option value="September">September</option>
                            <option value="October">October</option>
                            <option value="November">November</option>
                            <option value="December">December</option>
                        </select>
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="year" className="profile-label">Select Year</label>
                        <select 
                            label="From" 
                            name="from" 
                            className="form-control"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                        >
                            <option value="SelectYear">Select Year</option>
                            {(() => { const years = []; for (let y = 2022; y <= new Date().getFullYear() + 1; y++) years.push(y); return years; })().map((y) => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="doctor" className="profile-label">Select Organization </label>
                            <select 
                            label="doctor" 
                            name="doctor" 
                            className="form-control"
                            value={doctorId}
                            onChange={(e) => setDoctorId(e.target.value)}
                            >
                            <option value="undefined">Select Organization</option>
                            {doctors && doctors.map((doc, index) => (
                                <option value={doc?._id} key={index}>{formatClinicianName(doc)}</option>
                            ))}    
                    </select>
                    </div>

                    <div>
                        <label>&nbsp;</label>
                        <button className="edit-pill mt-4" onClick={generateInitialReport}>Search</button>
                    </div>
                
                </div>

                 {/* Heading */}
                     {loading ? <Loader /> : <>
                     {initialMonthPatients && initialMonthPatients?.data?.length > 0 && (<Fragment>
                    <hr />
                    <div className="row-display">
                     <div>
                         <p style={{color: 'gray', fontWeight: 'bold'}}>Results Found: <span style={{color: '#8FBB2C'}}>{initialMonthPatients && initialMonthPatients.length} </span></p>
                     </div>

                    <div>
                        <ExportReactCSV csvData={tableSort.rows} fileName="InitialMonthPatients.csv" />
                    &nbsp;&nbsp;
                    <button className="edit-pill" onClick={resetHandler}>Reset</button>
                    </div>

                    </div>
                    <br/>
                    </Fragment>)}                     
                
                {/* Heading */}


                {initialMonthPatients?.data?.length > 0 && (
                    <table className="table table-sm mb-2" aria-label="Sort initial month report">
                        <thead>
                            <tr>
                                <th>Sort by:</th>
                                <SortableTh sortKey="name" sort={tableSort}>Patient</SortableTh>
                                <SortableTh sortKey="dob" sort={tableSort}>DOB</SortableTh>
                                <SortableTh sortKey="emrId" sort={tableSort}>EHR ID</SortableTh>
                                <SortableTh sortKey="provider" sort={tableSort}>Provider</SortableTh>
                                <SortableTh sortKey="nurse" sort={tableSort}>Nurse</SortableTh>
                            </tr>
                        </thead>
                    </table>
                )}
                {initialMonthPatients && tableSort.rows.map((initialreport, index) => (
                    <Fragment>
                        <div className="row" key={index}>
                           <div className="col-md-1">
                               <span>{index + 1}</span>
                           </div>
                            <div className="col-md-3">
                                <b>Patient Details</b>
                                <br/><br/>
                                <span>EHR-ID: {initialreport?.emrId}</span><br/>
                                <Link style={{color: 'dodgerblue', fontWeight: 'bold'}} 
                                    to={{ pathname: "/patientProfile", state: {patientid: initialreport?._id}}}>
                                    {initialreport?.lastname +" , "+ initialreport?.firstname}
                                </Link><br/>
                                <span>DOB: {formatDob(initialreport?.DOB)}</span><br/>
                                <span>Gender: {initialreport?.gender}</span><br/>
                                <span>Email: {initialreport?.email}</span><br/>
                                <span>Phone 1: {initialreport?.phone1}</span> <br/>
                                <strong style={{color: '#004aad'}}>Initial Month: </strong> {month} {year} <br/>
                            </div>

                            <div className="col-md-3">
                                <b>Organization Details</b>
                                <br/><br/>
                                <span>Name:{formatClinicianName(initialreport?.assigned_doctor_id)}</span><br/>
                            </div>

                            <div className="col-md-2">
                                <b>Nurse Details</b>
                                <br/><br/>
                                <span>Name: {initialreport?.assigned_hr_id?.lastname +" , "+ initialreport?.assigned_hr_id?.firstname}</span><br/>
                                <span>Gender: {initialreport?.assigned_hr_id?.gender}</span><br/>
                            </div>

                            <div className="col-md-3">
                                <b>Assigned Device( s ) </b>
                                <br/><br/>
                                {initialreport?.assigned_devices && initialreport?.assigned_devices.map((device, index) => (
                                    <div key={index}>
                                        <span>Device ID: {device?.deviceObjectId?._id}</span><br/>
                                        <span>{device?.deviceObjectId?.deviceType === 'bp' ? 'Cuff Telemetry Device' : device?.deviceObjectId?.deviceType}</span><br/>
                                        <span>IMEI: {device?.deviceObjectId?.imei}</span><br/>
                                        <strong style={{color: '#004aad'}}>Assign Date: {formatDeviceAssignedDate(device?.deviceObjectId?.assignedTime, '---')}</strong> <br/>
                                        <br/>
                                    </div>
                                    
                                ))}
                                
                            </div>
                        </div>
                        <hr />
                    </Fragment>
                ))}
                </>}
            </div>
        </div>


        </section>
    </Fragment>
  )
}

export default InitialMonthReport